import { Inject, Component } from "@angular/core";
import { ConfigurationSessionManager, ConfiguratorStore, ConfPageSessionService } from "../providers";
import * as Immutable from 'immutable';
import { SummaryBaseComponent } from "./summaryBaseComponent";
import { ConfUIItem, CodeDisplayStyles, CodeDecoration, GroupConfUIItem, DocumentsDecoration, ConfFormValue, FormDecoration } from "../../shared/models";
import { ProductDataStore } from "../../shared/providers/productData";
import { CodeValueModelBuilder } from "../../shared/components/code/providers/codeValueModelBuilder";
import { CodeDecorationValuesModel } from "../../shared/components/code/codeDecorationValueModel";
import { GlobalDataStore } from "../../shared/providers/globalData/globalDataStore";
import { VisualObjectUIDataService } from "../shared/visualObjectUIDataService";
import { FormValueModelBuilder } from "../../shared/components/form";
import { VisualObjectHelper } from "../parameters/shared";


export enum ActionBoxNames {
  Operations = 'operations',
  States = 'states',
  Revisions = 'revisions',
  Reports = 'reports',
  Forms = 'forms',
  Code = 'code',
  Documents = 'documents',
  Graphics = 'graphics',
  Attachments = 'attachments'
}

@Component({
  selector: 'summary-action-boxes',
  templateUrl: './summaryActionsBoxesComponent.html',
  providers: [VisualObjectUIDataService, VisualObjectHelper]
})
export class SummaryActionsBoxesComponent extends SummaryBaseComponent {
  actionBoxNames = ActionBoxNames;

/*  codeUIItems: Immutable.List<ConfUIItem> = Immutable.List<ConfUIItem>();*/
  documentsUIItems: Immutable.List<ConfUIItem> = Immutable.List<ConfUIItem>();

  formDecorations: Immutable.List<FormDecoration> = Immutable.List<FormDecoration>();

  orderList: Immutable.List<string> = Immutable.List<string>();

  // List of each decoration values.
  decorationValuesModels: Immutable.List<CodeDecorationValuesModel> = Immutable.List<CodeDecorationValuesModel>();

  constructor(@Inject(ConfPageSessionService) public confPageSessionService: ConfPageSessionService,
    @Inject(CodeValueModelBuilder) public codeValueModelBuilder: CodeValueModelBuilder,
    @Inject(FormValueModelBuilder) public formValueModelBuilder: FormValueModelBuilder,
    @Inject(GlobalDataStore) public globalDataStore: GlobalDataStore) {
    super(confPageSessionService);
  }

  onDataReady(): void {

    this.orderList = this.globalDataStore.globalSettings.summaryActionBoxesDisplayOrder;

    // TODO: This part requires more improvement.
    const uiItems: Array<ConfUIItem> = this.confPageSessionService.activeConfiguration.uiItems
      .filter(uiItem => uiItem.itemName == CodeDecoration.name).toArray();

    if (this.globalDataStore.globalSettings.displayDocumentsInOperationsColumn)
      this.documentsUIItems = this.confPageSessionService.activeConfiguration.uiItems
        .filter(uiItem => uiItem.itemName == DocumentsDecoration.name).toList();

    const formUIItems: Array<ConfUIItem> = this.confPageSessionService.activeConfiguration.uiItems
      .filter(uiItem => uiItem.itemName == FormDecoration.name).toArray();

    const codeFilteredStyles = [CodeDisplayStyles.DownloadLink, CodeDisplayStyles.Popup];

    this.decorationValuesModels = this.decorationValuesModels.clear();
    uiItems.forEach(x => {

      // Note! Grouping is not supported yet for action boxes. We need more work on this part.
      let ValuesModels = this.codeValueModelBuilder.build(x, false, codeFilteredStyles, this.configurationId).toArray();
      this.decorationValuesModels = this.decorationValuesModels.push(...ValuesModels);

    });

    this.formDecorations = this.formDecorations.clear();
    formUIItems.forEach(x => {

      // Note! Grouping is not supported yet for action boxes. We need more work on this part.
      let formDecoration = this.formValueModelBuilder.build(x, false);

      if (formDecoration)
        this.formDecorations = this.formDecorations.push(formDecoration);

    });

  }

}